import React, { useEffect, useRef } from 'react';

export default function Calendly() {
  const containerRef = useRef(null);

  useEffect(() => {
    // Inject Cal.com embed bootstrap script once and initialize the namespace
    (function (C, A, L) {
      let p = function (a, ar) { a.q.push(ar); };
      let d = C.document;
      C.Cal = C.Cal || function () {
        let cal = C.Cal;
        let ar = arguments;
        if (!cal.loaded) {
          cal.ns = {};
          cal.q = cal.q || [];
          d.head.appendChild(d.createElement('script')).src = A;
          cal.loaded = true;
        }
        if (ar[0] === L) {
          const api = function () { p(api, arguments); };
          const namespace = ar[1];
          api.q = api.q || [];
          if (typeof namespace === 'string') {
            cal.ns[namespace] = cal.ns[namespace] || api;
            p(cal.ns[namespace], ar);
            p(cal, ['initNamespace', namespace]);
          } else {
            p(cal, ar);
          }
          return;
        }
        p(cal, ar);
      };
    })(window, 'https://app.cal.com/embed/embed.js', 'init');

    window.Cal('init', 'discovery', { origin: 'https://cal.com' });

    window.Cal.ns.discovery('inline', {
      elementOrSelector: '#cal-inline-embed',
      config: { layout: 'month_view' },
      calLink: 'one-up-n0typj/discovery',
    });

    window.Cal.ns.discovery('ui', {
      theme: 'dark',
      cssVarsPerTheme: {
        light: { 'cal-brand': '#1A75FF' },
        dark: { 'cal-brand': '#1A75FF' },
      },
      hideEventTypeDetails: false,
      layout: 'month_view',
    });
  }, []);

  return (
    <section id="book-call" className="calendly-section">
      <div className="container-x">
        <div className="section-intro">
          <span className="eyebrow reveal">Book a call</span>
          <h2 className="section-heading reveal reveal-delay-1" style={{ marginTop: 24 }}>
            Book a Free <span className="text-gradient">Strategy Call</span>
          </h2>
          <p className="reveal reveal-delay-2" style={{ color: '#AAAAAA' }}>
            Schedule a 30-minute discovery call with our team — no fluff, just a focused conversation about your pipeline.
          </p>
        </div>

        <div className="calendly-wrap reveal">
          <div className="calendly-glow-a" aria-hidden="true" />
          <div className="calendly-glow-b" aria-hidden="true" />
          <div className="calendly-card">
            {/* Cal.com inline embed */}
            <div
              id="cal-inline-embed"
              ref={containerRef}
              className="calendly-inline-widget"
              style={{ minWidth: 320, height: 700, width: '100%', overflow: 'auto' }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
